module.exports = __webpack_public_path__ + "img/06马超.baa96e4b.png";